import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    // primary: {
    //   100: "#A0532C",
    //   200: "#d78825",
    //   300: "#DF4505",
    //   // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
    //   400: "#C16436",
    //   500: "#d78825",
    //   600: "#d78825",
    // },
    // secondary: {
    //   100: "#BFBFBF",
    //   200: "#A0532C",
    //   300: "#C16436",
    // },
    // background: {
    //   100: "#FAF2EE",
    //   200: "#EBE9E9",
    //   300: "#DAD4D5",
    //   400: "#FAF2EE",
    // },
    primary: {
      100: "#C16436",
      200: "#d78825",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#C16436",
      500: "#d78825",
      600: "#d78825"
    },
    secondary: {
      100: "#BFBFBF",
      200: "#AF272F",
      300: "#C16436"
    },
    background: {
      100: "#FAF2EE",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#FAF2EE"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#00B0B9",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    calendarCtaBorderRadius: 8,
    outletLocationRestText: "#C16436",
    orderOnlineHomeButton: "#C16436",
    errorModalHeaderBg: "#FAF2EE",
    locationListBtn: "#C16436",
    circularAddBtn: "#C16436",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    secondary200Mobile: "#A0532C",
    startBgColor: "#FAF2EE",
    profileHeaderBackground: "#C16436",
    locationTopTabColor: "#C16436",
    confirmationModalOptionBg: "#FAF2EE",
    asapOptionBg: "#FAF2EE",
    bannerDropShadow: "#5F2C2D",
    asapTextColor: "#404040",
    cartNumberText: "#ffff",
    menuItemCardBg: "#FAF2EE",
    checkbackSoonBgImgOverlayColor: "#FAF2EE",
    hStackArrowsBg: "#FDFDFDD9",
    menuItemCardBorder: "transparent",
    selectedMenuCategoryBorder: "#C16436",
    themeErrorColor: "#F5D6D8",
    themeErrorTextColor: "#CD3838",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#FFFFFF",
    specialInstArrowColor: "black",
    modalDarkBg: "#FFFFFF",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    listItemDivider: "#D6D6D6",
    categoryBoxDivider: "#D6D6D6",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    themeSectionTextDark: "#8A8A8A",
    infoLinkColor: "#C16436",
    backLinkColor: "#D38232",
    themeTextColor: "#020001",
    legalDesclaimerText: "#020001",
    themeGrey: "#606060",
    headerBackground: "white",
    mobilePayHeaderBtnBorder: "#C16436",
    themeDarkGrey: "#2E2A26",
    orderSettingsDateTimeChoiceColor: "#C16436",
    selectedOptionBorderColor: "#C16436",
    menuDetailsMobileHeaderText: "#C16436",
    configOptionsAccordionBackground: "#C16436",
    hStackArrowsColor: "#C16436",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#C16436",
    categoryHeaderSeparator: "#EAEAEA",
    btnHoverColor: "#ab4520",
    menuListTooltipBg: "#C16436",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#C16436",
    menuDetailTooltipColor: "#FFFFFF",
    wcacSecondaryBtnBorder: "#C16436",
    categoryNavBgColor: "#FAF2EE",
    menuItemNameColor: "#332C28",
    downArrowColor: "#020001",
    legalTextContainerBg: "#EFEFEF",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    mobileBg: "#FFFFFF",
    menuLinksColor: "#606060",
    cartNoOfItemsText: "#C16436",
    cartItemPrice: "#C16436",
    cartPhoneNumber: "#C16436",
    cartItemActionBtn: "#C16436",
    cartHeaderOrderType: "#332C28",
    cartHeaderLocationName: "#C16436",
    checkoutButtonBackgroundColor: "#C16436",
    selectedCarouselItemWithoutImage: "#FAF2EE",
    unselectedCarouselItemWithoutImage: "#ffff",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    menuItemAddButtonColor: "#C16336",
    // Newly added token names from other brand theme (OG && LH)
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    deliveryModalNameColor: "#A2402A",
    sliderItemColor: "#C26435",
    headerBackgroundTop: "white",
    // Menu Listing
    menuButtonBackgroundColor: "#C16436",
    orderSettingsTextColor: "#C16436",
    categoriesText: "#C16436",
    modalCategoriesText: "#C16436",
    inActiveCategoriesText: "#606060",
    inActiveModalCategoriesText: "#606060",
    menuItemPriceColor: "#332C28",
    menuItemCalorieColor: "#332C28",
    scrollToTopColor: "#C16436  ",
    itemAddToCartPopupBackground: "#C16436",
    recommendationaInfoTextColor: "#020001",
    reorderInfoTextColor: "#332C28",
    reorderHeadingsText: "#020001",
    // Menu Details
    notSelectedOptionBorderColor: "#D7D7D7",
    sliderWithButtonsBackground: "#FFFFFFE5",
    recommendationHeadingColor: "#020001",
    menuDetailAccordionDownArrowColor: "#C16436",
    menuDetailAccordionTextColor: "#332C28",
    legalDisclaimerText: "#020001",
    menuDetailsAccordionDetailsBackground: "#F7F7F7",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#020001",
    menuDetailTemparatureSliderLabelColor: "#303030",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "#E9E9E9",
    menuDetailItemNameColor: "#2A2C25",
    plusIconColor: "#C16436",
    menuDetailsItemPriceColor: "#020001",
    menuDetailsItemDescriptionColor: "#020001",
    menuDetailsItemCaloriesCaolor: "#020001",
    menuDetailsModifiersBorderColor: "#C26435 ",
    menuDetailsSliderHoverColor: "#C16436",
    menuDetailsBackToMenu: "#D38232",
    menuDetailsSliderItemBackground: "#EBE9E9",
    loginModalTextColor: "#737373",
    requiredTextColor: "#C26435",
    nutritionalHTMLColor: "#020001",
    // Menu Details END
    orderConfirmationTextColor: "#C16436",
    locationListingItemText: "#020001",
    locationListingItemHeading: "#020001",
    locationListingItemHeadingMobile: "#C16436",
    confirmPickupDetailsText: "#2D2926",
    addressTextColor: "#303030",
    itemIsFor: "#606060",
    itemIsForName: "#332C28",
    cartItemTitle: "#332C28",
    specialInstructions: "#332C28",
    cartItemOption: "#030000",
    emptyCartHeaderBgColor: "#FAF2EE",
    locationsNear: "black",
    ninjaIconColor: "#C16436",
    searchResultsName: "#303030",
    locationConfirmationHeadings: "#C16436",
    orderSettingsDesktop: "#4B312A",
    orderSettingsMobile: "#332C28",
    previousOrderItemStatus: "#AF272F",
    accordionDescription: "white",
    skuUnavaliableTextColor: "#A2402C",
    waitlistRestaurantInfoBoxText: "#603D20",
    youMightLikeBannerColor: "#01AFB7",
    defaultMenuBannerBg: "#2f2f2f",
    defaultMenuTextColor: "white",
    quantityArrowColor: "#C16436",
    textCTAColor: "#C16436",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    reOrderAddBtnBorder: "#C16436",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    selectedListItem: "#FAF2EE",
    locationListItemBorder: "rgba(0,0,0,.1)",
    allLocationsSelectBgMobile: "#F0FFFF",
    allLocationsSelectBgDesktop: "#F0FFFF",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#ffffff",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#C16436",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#020001",
    categoriesDescriptionColor: "#020001",
    itemUnavailableCardBg: "#FAF2EE",
    itemCardBg: "#FAF2EE",
    itemCardBgLight: "#FAF2EE",
    // ORDER CONFIRMATION START
    orderConfirmationCustomerEmail: "#332C28",
    orderConfirmationBackground: "#F6F6F6",
    confirmationPrimary: "#C16436",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#C16436",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#FAF2EE",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#FAF2EE",
    selectedSKUItem: "#FAF2EE",
    configOptionBg: "white",
    nonSelectedSkuItem: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#FAF2EE",
    selectedDescriptionText: "#020001",
    // RESTAURANT DETAILS START
    // restaurantTimingsHeadingTextColor: "#C16436",
    // joinWaitlistButtonColor: "#C16436",
    // mobileOrderHistoryItemCardHeaderBackgroundColor: "#FAF2EE",
    restDetailsRestInfoTitleColor: "#603D20",
    // restaurantInfoNumberAndDistanceTextColor: "#C16436",
    restDetailsName: "#A0532C",
    // RESTAURANT DETAILS END
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#020001",
    registerTextColor: "#020001",
    recommendationsHeadingColor: "#020001",
    capacityInfoText: "#606060",
    selectedStateColor: "#000000",
    quantityColor: "#020001",
    timeDropdownColor: "#000000",
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#4D2C42",
    locaionAndTimeHeaderBg: "#FAF2EE",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#C16436",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#C16436",
    orderStatusSectionBg: "#F8F4E9",
    refreshButtonColor: "#C16436",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    orderStatusSectionBorderColor: "#DCDCDC",
    refreshButtonBg: "#FFFFFF",
    // order tracking page end
    toggleColor: "#000000",
    onboardingScreenBGColor: "#FFF",
    onboardingButtonBackgroundColor: "#C16436",
    onboardingButtonTextColor: "#FFFFFF",
    onboardingActiveDotColor: "#54301A",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.2)",
    checkoutGratuitySliderMinTrackColor: "#A0532C",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    menuCustomisationIsSelectedMobileColor: "#FAF2EE",
    menuCustomisationIsSelectedBorderMobileColor: "#C16436",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    //
    //
    ///
    //
    //
    //copied from og
    grey300: "#303030",
    mobileGetStartedButtonColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    smartRecommendationCardbg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#cb7034",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "#6F3D31",
    linearGradientHeaderLight: "rgba(0,0,0,0)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    lunchIssueModalBody: "#F8F7F6",
    lunchIssueModalSeparator: "#EBE9E9",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#D5D2CB",
    //"#ABABAB",
    mobileOrderDetailsBanner: "#FAF2EE",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#81312F",
    restaurantLabelColor: "#81312F",
    joinWaitlistColor: "#CA7C30",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#A2402A",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#2A2C25",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#CA7C30",
    restaurantAboutSectionHeadingTextColor: "#2A2C25",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantHoursTextColor: "#2A2C25",
    remoteCheckinWaitTimeBg: "#FAF2EE",
    remoteCheckinWaitTimeBorderTwo: "rgba(193, 100, 54, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(193, 100, 54, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(193, 100, 54, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinWaitTimeHeaderText: "rgba(160, 83, 44, 1)",
    remoteCheckinWaitTimeText: "rgba(193, 100, 54, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#C16436",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#4B312A",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#603D20",
    restaurantTimingsTextColor: "#404040",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.2)",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    jwxLeaveTheLineCancelBtnBorder: "#C16436",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: "#F6F6F6",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "#4B312A",
    mobileGiftCardGradientSecond: "#C16436",
    myAccountGiftCardLargeBorderRadius: 26,
    mobileMasterCardGradientFirst: "#1D338F",
    mobileMasterCardGradientSecond: "#1D338F",
    mobileMasterCardGradientThird: "#255C95",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#8A8A8A",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BE6336",
    waitlistHomeScreenBannerGradientTwo: "#4E332B",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(193, 100, 54, 0.4)",
    waitlistPositionInnerBorder: "#C16436",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenMobileBackgroundColor: "#F6F6F6",
    myAccountScreenWebBackgroundColor: "#fff",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#BF7D3F",
    curbsideHomeScreenBannerGradientTwo: "#964631",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#FAF2EE",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#993324",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#FFFFFF",
    restCallNowCTATextColor: "#FFFFFF",
    homeScreenHeaderIconColors: "#FFFFFF",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    homeScreenLoginBorderColor: "#FFFFFF",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    showCreditCard_bottomSheet_BackgroundColor: "#FFFFFF",
    addEditCreditCard_scrollView_backgroundColor: "#F6F6F6",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#F6F6F6",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    jwcOrderAheadImgOverlayShade: "rgba(0, 0, 0, 0.4)",
    appleSocialSignInBGColor: "#000000",
    jwcBgColor: "#EFEFEF",
    jwcLeaveTheLineModalHeadBg: "#C4C4C4",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F2EFEA",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#C16436",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#C16436",
    selectedNumberOfGuestBackgroundColor: "#C16436",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#a18e82",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#404040",
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#CA7C30",
    backgroundE5E5: "#E5E5E5",
    searchKeywordHighlightColor: "#C16436",
    menuSearchBarContainerBg: "#FFFFFF",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#FAF2EE",
    paymentOptionsBorderColor: "#DCDCDC",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#D30000",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "#D5D2CB",
    //menu-collapsable bg
    menuCollapsableButton: "#FAF2EE",
    //number of guests bg
    numberOfGuestsActiveColor: "#FFFFFF",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#A0532C",
    // cart item qty color
    cartItemQuantityColor: "#A0532C",
    homescreenWaitlistButtonBorderColor: "#A0532C",
    homescreenWaitlistButtonTextColor: "#A0532C",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    waitlistBannerBg: "#C16436",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistBottomBackground: "#FAF2EE",
    waitlistDisclaimer: "#303030",
    fwlvMiddleCtaBackground: "#EEDDD4",
    waitlistTableHeaderBg: "#F8F8F8",
    selectedWaitlistRow: "#FAF2EE",
    howItWorksHeaderBg: "#FAF3EE",
    howItWorksBannerBg: "#C16436",
    //Menu search
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "white",
    menuSearchModalDivider: "#ABABAB",
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#DF4505",
    searchBarBorderColor: "#D6D6D6",
    searchItemCardTextColor: "#505050",
    searchCardCategorySlugColor: "grey",
    // statuses colours:
    highWait: "#CA7C30",
    lowWait: "#CA7C30",
    waitNotAvailable: "#BDBDBD",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    recentOrdersListItemPrice: "#B31900",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#C16436",
    profileHeaderLinearGradientEndColor: "#C16436",
    profileAddCardButtonText: "#FFFFFF",
    mobilePayConfirmationScreenBlockBG: "#F3EEE9",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#DDC274",
    reservationSelectedCTABGColor: "#EDDFCB",
    locationsTopTabsContainerColor: "#FFFFFF",
    menuSearchModalCloseIconBg: "#FAF2EE",
    searchItemBreadCrumbSlugcolor: "#666666",

    /* Restaurant Details */
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#C16436",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#C16436",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#FAF2EE",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#603D20",
    restaurantDetailsNotSelectedWeekDayTextColor: "#303030",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restaurantTimingWeekDayTextColor: "#4B312A",
    orderFromHereButtonTextColor: "#FFFFFF",
    amenitiesActionButtonsColor: "#C16436",
    restaurantImageBorderColor: "#FFFFFF",
    joinWaitlistBackgrouondColor: "#F6F6F6",
    joinWaitlistFormBgColor: "#FFFFFF",
    joinWaitlistFormBorder: "#DEDEDE",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    // waitlistBannerBg: "#A8AD00",
    // waitlistTableHeaderBg: "#F8F8F8",
    // waitlistBottomBackground: "#F3F4EA",
    // selectedWaitlistRow: "#F3F4EA",
    // waitlistFooterBorderTop: "#393939",
    // howItWorksBannerBg: "#9FA73A",
    // howItWorksHeaderBg: "#F3EFEB",
    // waitlistDisclaimer: "#231815",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#332C28",
    weekDayBorderColor: "#DCDCDC",
    orderTotalTextColor: "#603D20",
    orderTotalPriceColor: "#603D20",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    jwcArrowColor: "#603D20",
    breadSticksArrowColor: "#603D20",
    waitlistStatusScreenBg: "#FAF2EE",
    waitlistVisibilityAddressBoxArrow: "#603D20",
    howItWorksText: "#C16436",
    waitlistVisibilityModalBg: "#000000B2",
    imageStackBorderColor: "#FFFFFF",
    waitlistTableRowSeperator: "#EFEFEF",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#D6DCD2",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistTableInfoBg: "#C16436",
    waitlistTableInfoText: "#ffffff",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#C16436",
    homescreenLocationTextColor: "#303030",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#C16436",
    locationSearchActive3Tab: "#A0532C",
    locationSearchActive3TabTextColor: "#FFFFFF",
    locationSearchInActive3TabTextColor: "#606060",
    locationSearch3Tabs: "#E5E4E0",
    searchBarBackgroundForThreeTabs: "#F2F0F0",
    searchThisAreaBg: "#F1844D",
    locationSearchInActiveTab: "#808080",
    searchCurrentLocation: "#C16436",
    registerLsBtn: "#C16436",
    callRestLsText: "#C16436",
    mobilePayICheckError: "#3F3C3C",
    locationSearchAddressColor: "#020001",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    locationListingItemHeadingInPage: "#C16436",
    locationSearchTabDivider: "#DEDEDE",
    locationSearchTabBgColor: "transparent",
    lsAllLocationsSelectBorder: "#D6D6D6",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#C16436",
    hoursInfoAccordionTitle: "#603D20",
    joinWaitlistBtnHover: "#C16436",
    joinWaitlistBtnTextHover: "white",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#C16436",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#C16436",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#964631",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#A0532C",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#FAF2EE",
    topTabCountInactiveBg: "#DAD4D5",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#FAF2EE",
    criticalModeBg: "#fafafa",
    viewMenuHover: "#b0613a",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#4E311D",
    reorderAddItemBg: "#C16436",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#A0532C",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#A0532C",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuListSkeletonHeaderContainerBackground: "#F8F8F8",
    menuListSkeletonHeaderBackground: "#FFF",
    menuListSkeletonCategoryNavigationBgColor: "#F8F8F8",
    menuListSkeletonTopTabActiveBottomBorderColor: "#C16436",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#C16436",
    selectedOrderTypeTextColor: "#C16436",
    reservationsLocationCardBg: "#FFFFFF",
    reservationDetailsCTABg: "#FFFFFF",
    reservationAvailableTimeSlotBg: "transparent",
    reservationTimeSlotsItemInactiveBg: "#D8DCE0",
    reservationsSpecialRequestBg: "transparent",
    reservationsConfirmationDetailsBg: "#FFFFFF",
    reservationHeaderTitleColor: "#404040",
    reservationDOBBgColor: "transparent",
    reservationsCardBg: "#fff",
    modalHeaderColor: "#fff",
    modalHeaderTextColor: "#404040",
    mobileCalendarTextColor: "#C16436",
    gcBalanceRefreshBorderTextColor: "#C16436",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000",
    confirmationModalBorderRadius: 4,
    reservationPopupBgColor: "#FFFFFF",
    reservationsTimePickerBg: "#FFF",
    eClubHoverActiveColor: "#FAF2EE",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#FAF2EE",
    eClub_confirmation_background_color: "#F2EFEA",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F2EFEA",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    smartRecommendationModalCloseIconColor: "#737373",
    noReservationBorder: "transparent",
    networkIndicatorColor: "black",
    desktopTopTabsBG: "transparent",
    menuSearchModalCloseIconColor: "black",
    menuSearchInputBorder: "primary.100",
    menuSearchResultContainerBG: "#fff",
    pdRequestFormBG: "#fff",
    myAccountBgImageOverlay: "#FAF2EE",
    myAccountBgColor: "#FAF2EE",
    myAccountCardBackgroundActive: "#FAF2EE",
    myAccountChangeFieldModalBg: "white",
    myAccountEditProfileScrollViewBg: "white",
    myAccountAddGiftCardsPopover: "#C16436",
    myAccountDOBYearBgColor: "transparent",
    myAccountDOBMonthBgColor: "transparent",
    myAccountDOBTextColor: "#C16436",
    myAccountCalendarCtaBorderRadius: 6,
    myAccountMenuItemActiveTextColor: "#C16436",
    myAccountMenuItemInActiveTextColor: "#303030",
    refreshIconColor: "#C16436",
    editProfileFullBottomButtonBackgroundColor: "white",
    orderHistoryFullBottomButtonBackgroundColor: "white",
    orderHistoryDetailsHeaderModalBackgroundColor: "white",
    pdInputDataTextColor: "#000",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    menuListingContainerBG: "#fff",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "#fff",
    joinEclubContainerBgColor: "#FAF2EE",
    editProfile_modalHeaderBackgroundColor: "#FFFFFF",
    editProfile_modalBodyBackgroundColor: "#F6F6F6",
    confirmationModalCTABackgroundColor: "#C16436",
    giftCardLargeBody_BackgroundColor: "#FAFAFA",
    giftCardLargeBody_webModalBackgroundColor: "#F6F6F6",
    giftCardLargeHeader_BackgroundColor: "#FAFAFA",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#FFFFFF",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#FFFFFF",
    orderHistoryModalHeaderTextColor: "#404040",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    EclubFormInputPlaceholderTextColor: "#989182",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    joinEclubDOBTextColor: "#C16436",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    myAccountSkipConfirmationCTA: "#C16436",
    paymentOptions_giftCard_balanceAmountColor: "#000000",
    EClubInputErrorColor: "#D30000",
    EClubLocationBottomLabelTextColor: "#808080",
    menuItemcardVerticalImageBorderRadius: "xl",
    globalBannerBg: "#c16436",
    EclubDOBBottomBorderColor: "#606060",
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#FAF2EE",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    orderDetailsCartItemPrice: "#000000"
  },
  components: {
    Pressable: {
      variants: {
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 50
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderRadius: 5,
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2,
              borderRadius: 8
            },
            _android: {
              py: 2,
              borderRadius: 8
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "100%",
              lg: "261px"
            },
            _web: {
              minH: "48px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            borderRadius: 8,
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref4) {
          var disabled = _ref4.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "48px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        // JOIN WAITLIST START
        joinWaitlist_Guests_Number_Container: function joinWaitlist_Guests_Number_Container(_ref5) {
          var selected = _ref5.selected;
          return {
            shadow: selected ? 8 : "none",
            width: {
              base: "44px",
              lg: "56px"
            },
            height: {
              base: "40px",
              lg: "51px"
            },
            bg: selected ? "secondary.300" : "white",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 6,
            borderWidth: 1,
            borderColor: selected ? "secondary.300" : "#DEDEDE"
          };
        },
        joinWaitlist_CTA_Cancel_Button: function joinWaitlist_CTA_Cancel_Button() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 24
            },
            borderWidth: 1,
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        joinWaitlist_CTA_JW_Button: function joinWaitlist_CTA_JW_Button(_ref6) {
          var disabled = _ref6.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 20
            },
            borderWidth: 1,
            borderColor: disabled ? "#DADADA" : "amenitiesActionButtonsColor",
            bgColor: disabled ? "#DADADA" : "amenitiesActionButtonsColor"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref7) {
          var radiusValue = _ref7.radiusValue,
              topRadiusValue = _ref7.topRadiusValue,
              bottomRadiusValue = _ref7.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        eClubStickySignUpDesktopPressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 10,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        // JOIN WAITLIST END
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        },
        // My Account starts
        myAccount_edit_fields_sheet_title_container: {
          bg: "white",
          width: "100%"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_infoList_changeOperation_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          shadow: 17,
          py: 5,
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 8
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: {
          my: 1,
          borderRadius: 8,
          _web: {
            my: 0
          },
          flex: 1,
          ml: 2,
          backgroundColor: "secondary.300",
          border: 1.5,
          borderColor: "secondary.300"
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 8,
          py: 3,
          px: 4
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        myAccount_paymentOptions_checkBalanceCTA: {
          marginY: 1,
          border: 1.5,
          borderColor: "#C16436",
          borderRadius: 8,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        },
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 8,
          py: 3,
          px: 4
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "secondary.300",
          px: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          borderRadius: 10
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300",
          borderRadius: 8
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref8) {
          var isActive = _ref8.isActive;
          return {
            borderRadius: 8,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "white",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        } // My Account ends

      }
    },
    Button: {
      variants: {
        solid: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "primary.100",
            fontWeight: "600",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        remoteCheckinBodyBtn: {
          mt: 3,
          bg: "#C16436",
          _web: {
            width: {
              base: "80%",
              sm: "80%",
              md: "100%"
            }
          },
          pt: 3,
          pb: 3
        },
        wcacSecondaryBtn: {
          bg: "white",
          _hover: {
            bg: "background.100"
          },
          _pressed: {
            bg: "background.100"
          },
          border: 1,
          borderColor: "#C16436",
          mr: 3,
          _text: {
            px: 4,
            fontSize: 16,
            fontWeight: 400,
            color: "#C16436",
            textTransform: "uppercase"
          }
        },
        wcacPrimaryBtn: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#C16436"
          },
          _text: {
            px: 2,
            fontSize: 16,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        camAccessBtn: {
          bg: "#C16436",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          borderRadius: 4,
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          borderRadius: 4,
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },
        orderOnlineBtn: function orderOnlineBtn(_ref9) {
          var isLocationSearch = _ref9.isLocationSearch;
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: isLocationSearch ? "13" : "xs"
              },
              textTransform: "uppercase"
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink(_ref10) {
          var isLocationSearch = _ref10.isLocationSearch;
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: isLocationSearch ? "13" : "xs"
              },
              textTransform: "uppercase"
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "14px"
            },
            fontWeight: "400",
            color: "primary.100",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "headingSecondary"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref11) {
          var borderRadiusValue = _ref11.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref12) {
          var borderRadiusValue = _ref12.borderRadiusValue;
          return {
            borderRadius: borderRadiusValue || 0,
            backgroundColor: "secondary.300",
            shadow: 9
          };
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref13) {
          var borderRadiusValue = _ref13.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            }
          };
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 600,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#C16436",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "#C16436",
            fontWeight: 400
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref14) {
          var isActive = _ref14.isActive,
              isMobile = _ref14.isMobile,
              isLongText = _ref14.isLongText;
          return {
            ml: isLongText && isMobile && 5,
            px: isMobile ? 6 : 9,
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            _web: {
              width: !isMobile && (isLongText ? "100%" : "117px"),
              borderReadis: "17px"
            },
            width: 32,
            borderReadis: 4,
            height: {
              base: 8,
              md: 9
            },
            rounded: "full",
            _text: {
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px"
              },
              lineHeight: isMobile ? 4 : 6,
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "700",
              fontSize: isMobile ? "xs" : "sm",
              textTransform: "uppercase",
              fontFamily: "Roboto-Regular"
            }
          };
        },
        pillButton: function pillButton(_ref15) {
          var isActive = _ref15.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "primary.100"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref16) {
          var isUnavailable = _ref16.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "primary.100",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 8
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#C16436",
          borderWidth: 1
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: {
                base: "#A2402A",
                lg: "#54301A"
              },
              fontWeight: 400
            },
            borderColor: {
              base: "#A2402A",
              lg: "#54301A"
            },
            borderRadius: {
              base: "6px",
              lg: "2px"
            },
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _hover: {
              backgroundColor: "white"
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            border: 1
          };
        },
        preorderDineIn: {
          backgroundColor: "#C16436"
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "primary.100"
          };
        },
        // LS page
        locationListItemButtonBorderRadius: 6,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 6,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref17) {
          var radiusValue = _ref17.radiusValue,
              topRadiusValue = _ref17.topRadiusValue,
              bottomRadiusValue = _ref17.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 8
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },
        confirmAndAddToCartButton: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },
        ErrorDialogOKButton: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "secondary.300",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },
        editProfileFullBottomButton: {},
        orderHistoryReorderFullBottomButton: {},
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300"
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300"
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: {
            base: "md",
            md: "lg"
          },
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Oswald"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 8,
          fontFamily: "Roboto-Regular",
          fontSize: 18
        },
        borderRadiusValue: function borderRadiusValue(_ref18) {
          var radiusValue = _ref18.radiusValue,
              topRadiusValue = _ref18.topRadiusValue,
              bottomRadiusValue = _ref18.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        myAccountInputForm: {
          fontFamily: "Roboto-Regular"
        }
      },
      borderRadiusValue: function borderRadiusValue(_ref19) {
        var radiusValue = _ref19.radiusValue,
            topRadiusValue = _ref19.topRadiusValue,
            bottomRadiusValue = _ref19.bottomRadiusValue;
        return {
          borderRadius: radiusValue,
          borderTopRadius: topRadiusValue,
          borderBottomRadius: bottomRadiusValue
        };
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref20) {
          var isMandatory = _ref20.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "10"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        }
      }
    },
    ModalBody: {
      variants: {
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%"
          },
          _android: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: "#FFFFFF",
          borderRadius: 12,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 12,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref21) {
          var radiusValue = _ref21.radiusValue,
              topRadiusValue = _ref21.topRadiusValue,
              bottomRadiusValue = _ref21.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        editFieldsConfirmationModal: {
          borderRadius: 12,
          p: 12,
          bgColor: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          }
        },
        editFieldsSuccessModal: {
          borderRadius: 12,
          p: 12,
          maxWidth: {
            md: "588"
          },
          bgColor: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 12
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 12
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref22) {
          var isMandatory = _ref22.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref23) {
          var isMandatory = _ref23.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref24) {
          var isDefaultExpanded = _ref24.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "xl"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 12
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Container: function joinWaitlist_StaticMap_Container() {
          return {
            flexDirection: {
              md: "row"
            },
            m: 5,
            borderRadius: 16,
            overflow: "hidden",
            shadow: 10
          };
        },
        // JOIN WAITLIST END
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        }
      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 6,
          w: 0.4
        }
      }
    },
    Text: {
      defaultProps: {
        _ios: {
          paddingBottom: 1
        },
        _android: {
          paddingBottom: 1
        }
      },
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        breadsticksCheckoutBannerNumberText: {
          fontFamily: "youMightLikeText",
          fontStyle: "italic",
          fontWeight: 700,
          fontSize: 12,
          color: "#606060"
        },
        breadsticksCheckoutBannerText: {
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: 12,
          color: "#606060"
        },
        breadSticksTotalText: {
          fontSize: 16,
          fontWeight: 500,
          textTransform: "capitalize"
        },
        breadSticksTableHeader: {
          fontSize: 14,
          color: "#606060",
          textTransform: "capitalize"
        },
        breadSticksTableContent: {
          fontSize: 14,
          color: "#2A2C25"
        },
        breadSticksBanner: {
          color: "#603D20",
          fontFamily: "headingSecondary",
          fontSize: 18,
          fontWeight: 400,
          ml: 16
        },
        breadSticksBannerNumber: {
          color: "#603D20",
          fontFamily: "headingSecondary",
          fontSize: 20,
          fontWeight: 500
        },
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#55111E"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        OrderInfoBannerCartIconText: {
          pt: 1
        },
        LoginHeaderText: {
          pt: 1
        },
        checkoutTopLabelText: {
          pt: 1
        },
        emailReceiptText: {
          fontSize: 20,
          lineHeight: 5,
          fontWeight: 500,
          fontFamily: "headingSecondary",
          color: "#55111E"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary200Mobile"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        refreshErrorWaitlist: {
          fontSize: 14,
          fontWeight: 400
        },
        waitlistRestaurantInfoBoxTitle: {
          fontSize: 15,
          fontWeight: 500,
          color: "waitlistRestaurantInfoBoxText"
        },
        waitlistRestaurantInfoBoxBody: {
          lineHeight: 18,
          fontSize: 14,
          fontWeight: 300,
          color: "waitlistRestaurantInfoBoxText"
        },
        wcacPrimaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        wcacSecondaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "#C16436",
          textTransform: "uppercase"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase",
          fontWeight: 500
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#404040"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#303030"
        },
        jwcRestDetails: {
          color: "#603D20",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#603D20",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: {
            base: "#C16436",
            lg: "white"
          },
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#C16436"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#C16436",
            lg: "#C16436"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center",
          fontFamily: "Oswald"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#C16436",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: "#484238",
          lineHeight: 24
        },
        jwcWaitTimeVaryMobile: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#4B312A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#4B312A"
        },
        jwcTitle: {
          textAlign: "center",
          mt: 6,
          fontSize: 24,
          fontWeight: 500,
          color: {
            base: "#2A2C25",
            lg: "#4B312A"
          }
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: {
            base: "#2A2C25",
            lg: "#4B312A"
          },
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        //JWC ENDS
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        fwlvButtonText: {
          fontSize: 14,
          color: "#C16436",
          textAlign: "center",
          marginTop: 2,
          textTransform: "capitalize"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#C16436",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#603D20",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: {
            base: 20,
            md: 22
          },
          lineHeight: 22,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 3,
          px: 4,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          color: "#C16436"
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinTitle: {
          color: "#603D20",
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          textAlign: "center"
        },
        remoteCheckinWaitTimeThankYou: {
          color: "#2A2C25",
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySizePrefix: {
          color: "#603D20",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimePartySize: {
          color: "#603D20",
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 4
        },
        remoteCheckinBodyOrderAheadText: {
          fontSize: "22px",
          fontWeight: 700,
          color: "white"
        },
        enableLocationText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 15,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#603D20"
        },
        checkinSuccessModalHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 15,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#603D20"
        },
        checkinSuccessModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 12,
          px: 5,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 17,
          color: "#303030"
        },
        checkinErrorModalHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 18,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 6,
          color: "#603D20"
        },
        clearedWaitlistBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 16,
          px: 7,
          lineHeight: 22,
          color: "#231815"
        },
        clearedWaitlistHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 24,
          lineHeight: 27,
          color: "#603D20"
        },
        waitlistBannerHeaderText: {
          fontSize: 15,
          fontWeight: 600,
          color: "white"
        },
        checkinErrorModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 5,
          color: "#303030"
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 300,
          marginY: 11,
          marginX: 5
        },
        remoteCheckinBodyText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white"
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        categoryText: function categoryText(_ref25) {
          var isActive = _ref25.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "24px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        menuItemNameWeight: function menuItemNameWeight(_ref26) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref26.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 400,
            fontFamily: "Oswald",
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: ["xl", "xl", "32"],
            fontWeight: 600,
            fontFamily: "headingSecondary"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // mocks needs for values
            fontSize: [16, 16, 22],
            fontFamily: "headingSecondary",
            fontWeight: 400
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: ["md", "md", "xl"]
          };
        },
        locationText: {
          color: "primary.100",
          fontSize: "14px",
          fontFamily: "headingSecondary"
        },
        phoneNumberText: {
          color: "#544940",
          fontSize: "xs",
          fontFamily: "body",
          fontWeight: "300"
        },
        btnText: {
          color: "primary.100",
          fontFamily: "headingSecondary",
          _web: {
            fontSize: "14px"
          }
        },
        headerText: {
          color: "primary.100"
        },
        cartItemCancelText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 400
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 400,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: "md",
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            _web: {
              mb: {
                base: "6px",
                md: "8px"
              }
            },
            mb: {
              base: 1,
              md: 2
            },
            fontSize: ["xl", "xl", "4xl"],
            fontFamily: "headingSecondary",
            fontWeight: 600
          };
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref27) {
          var isMandatory = _ref27.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "28"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 0
            },
            _ios: {
              letterSpacing: 0
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary" // textTransform: "capitalize",

          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref28) {
          var isMandatory = _ref28.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "28"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            // textTransform: "capitalize",
            _ios: {
              fontSize: 18
            },
            _android: {
              fontSize: 18
            }
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref29) {
          var isMobile = _ref29.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark(_ref30) {
          var isMandatory = _ref30.isMandatory;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref31) {
          var isMandatory = _ref31.isMandatory,
              isDefaultExpanded = _ref31.isDefaultExpanded;
          return {
            _android: {
              fontSize: 15
            },
            _ios: {
              fontSize: 15
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 300,
            _web: {
              letterSpacing: "-0.3px",
              fontSize: {
                base: "xs",
                md: "md"
              }
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "themeTextColor"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "#CD3838",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#CD3838",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "16px",
                md: "28px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        OnboardingScreenTitleTextColor: {
          color: "secondary200Mobile",
          fontWeight: "500"
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "16px",
                md: "28px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            fontFamily: "headingSecondary",
            fontSize: 22,
            fontWeight: 700,
            color: "#2D2926",
            lineHeight: 6
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontFamily: "heading",
            fontSize: 16,
            lineHeight: 5,
            fontWeight: 600
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 500,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 13,
            fontWeight: 600,
            color: "orderConfirmationTextColor"
          };
        },
        cartItemMenuName: function cartItemMenuName(_ref32) {
          var inOrderDetails = _ref32.inOrderDetails;
          return {
            fontSize: 17,
            lineHeight: 5,
            _web: {
              letterSpacing: "-0.3px",
              width: {
                base: inOrderDetails ? "100%" : "164px"
              }
            },
            letterSpacing: "-0.3",
            width: {
              base: 40
            },
            fontWeight: 600,
            color: "menuItemNameColor"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xxs"
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName() {
          return {
            fontSize: 15,
            lineHeight: 5,
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: "-0.3",
            width: 40,
            noOfLines: 3,
            color: "menuItemNameColor"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontSize: "sm"
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            fontFamily: "headingSecondary",
            fontWeight: 600,
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            } // fontSize: { base: 3, md: 4 },

          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 14
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 300,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: 14,
            fontWeight: 400,
            pr: 1
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderOrderType",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderLocationName",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 300,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600
        },
        allLocationsSelectText: {
          fontSize: 20,
          fontWeight: 400
        },
        allLocationsText: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref33) {
          var addButtonText = _ref33.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 12 : "md",
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            _web: {
              fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : "md"
            },
            _ios: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            }
          };
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 1
        },
        cartItemRemoveText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 400
        },
        pdfMenuButtonText: {
          mt: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: {
          fontWeight: 400,
          fontSize: "sm",
          lineHeight: 14,
          textAlign: "left"
        },
        confirmationPickupRestName: {
          _web: {
            fontSize: {
              base: 12,
              lg: 16
            }
          },
          fontSize: {
            base: 15,
            lg: 14
          },
          lineHeight: 3
        },
        confirmationPickupRestNameTitle: {
          _web: {
            fontSize: {
              base: 12,
              lg: 16
            }
          },
          fontSize: {
            base: 15,
            lg: 14
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          _web: {
            marginBottom: 1
          },
          marginBottom: 0,
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        locationListRestaurantDetails: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          _web: {
            width: "70%",
            lineHeight: "18px"
          },
          fontWeight: 300,
          lineHeight: 4
        },
        locationListResturantAddressSecondLine: {
          marginTop: 0,
          marginBottom: 0
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#4E311D",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: {
              base: "400",
              lg: "700"
            }
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "orderConfirmationCustomerEmail",
            fontWeight: "400"
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#332C28",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "300"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#4D2C42",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "500"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#484238",
            fontSize: {
              base: 14
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#494949"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#4D2C42",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        restInfoTitle: function restInfoTitle() {
          return {
            fontSize: {
              base: 18,
              lg: 32
            }
          };
        },
        restDetailsHoursTitle: function restDetailsHoursTitle() {
          return {
            fontSize: {
              base: 20,
              lg: 30
            }
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "black",
            fontWeight: 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "#303030",
            fontWeight: 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            color: "black",
            fontSize: {
              base: 16,
              lg: 18
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            }
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 0
            },
            _android: {
              py: 0
            },
            marginBottom: 1.5,
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "secondary.200",
            fontWeight: 300,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#4D2C42",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationName: {
          fontSize: 14,
          color: "#303030",
          fontWeight: 300
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#A2402A",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          linHeight: 18
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 16,
            md: 16,
            lg: 18
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 300,
          my: 4,
          textAlign: "center",
          letterSpacing: 1
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        myLocationsLoginText: {
          fontWeight: 600,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        waitlistDisclaimer: {
          fontWeight: 200
        },
        waitlistOrder: {
          color: "#C16436",
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: 12
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        howItWorksStepsNumber: {
          fontWeight: 500,
          color: "#2C2A26",
          fontSize: 14
        },
        howItWorksSteps: {
          fontWeight: 300,
          color: "#2C2A26",
          fontSize: 14
        },
        howItWorksActionButton: {
          fontWeight: 300,
          fontSize: 16
        },
        howItWorksHeader: {
          fontSize: 14,
          fontWeight: 600
        },
        howItWorksBanner: {
          fontWeight: 300,
          fontSize: 14
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "menuItemNameColor",
            fontWeight: 400
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "2px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "18px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 6,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref34) {
          var customMarginHorizontal = _ref34.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 18
            },
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: [16],
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: "#303030"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#303030"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#54301A"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref35) {
          var disabled = _ref35.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 16,
              lg: 20
            },
            // mb: 4,
            color: "restaurantHoursTextColor",
            fontFamily: "Oswald"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#606060",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            fontFamily: "Oswald-Medium",
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: 16,
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: 14,
            fontWeight: 300,
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: "16px",
            textAlign: "center",
            color: "amenitiesActionButtonsColor",
            _ios: {
              textTransform: "uppercase"
            },
            _android: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: "20px",
            color: "amenitiesHeadingColor",
            fontFamily: "Oswald",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "12",
            lg: "16"
          },
          color: "#606060"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "white",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "16px",
            color: "orderFromHereButtonTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: {
              base: "restaurantDetailsSelectedWeekDayColor",
              lg: "restaurantTimingWeekDayTextColor"
            },
            fontSize: {
              base: "10",
              lg: "12"
            },
            position: "absolute"
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_RestName: function joinWaitlist_StaticMap_RestName() {
          return {
            fontSize: {
              base: 12,
              md: 16
            },
            lineHeight: 4,
            fontWeight: 400,
            color: "grey300",
            mb: 1,
            w: {
              md: "100%"
            },
            _ios: {
              maxW: 300
            },
            _android: {
              maxW: 300
            }
          };
        },
        joinWaitlist_StaticMap_RestAddress: function joinWaitlist_StaticMap_RestAddress() {
          return {
            fontSize: 12,
            fontWeight: 300,
            color: "themeGrey",
            lineHeight: 4,
            mb: 2
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Web: function joinWaitlist_StaticMap_ChangeLocation_Web() {
          return {
            fontSize: {
              lg: 16
            },
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            mt: 4,
            _ios: {
              textTransform: "capitalize"
            },
            _android: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Mobile: function joinWaitlist_StaticMap_ChangeLocation_Mobile() {
          return {
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 14,
            _ios: {
              fontSize: 12,
              textTransform: "capitalize"
            },
            _android: {
              fontSize: 12,
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_Guests_Title: function joinWaitlist_Guests_Title() {
          return {
            lineHeight: 4,
            letterSpacing: -0.3,
            fontWeight: 400,
            color: "grey300",
            fontSize: {
              base: "14",
              lg: "16"
            },
            textAlign: "center",
            pl: 4,
            mt: 2,
            mb: 2
          };
        },
        joinWaitlist_Guests_Number: function joinWaitlist_Guests_Number(_ref36) {
          var selected = _ref36.selected;
          return {
            fontSize: {
              base: 14,
              lg: 20
            },
            letterSpacing: -0.3,
            fontWeight: {
              base: "400",
              lg: "300"
            },
            color: selected ? "white" : "themeGrey"
          };
        },
        joinWaitlist_Guests_Note: function joinWaitlist_Guests_Note() {
          return {
            color: "themeGrey",
            fontSize: {
              base: "10",
              lg: "12"
            },
            lineHeight: 4,
            fontWeight: 400
          };
        },
        joinWaitlist_Guests_Note_Wrapper: function joinWaitlist_Guests_Note_Wrapper() {
          return {
            maxW: 300,
            textAlign: "center",
            mx: "auto",
            px: 4,
            mb: 2
          };
        },
        joinWaitlist_Guests_PhoneNumber: function joinWaitlist_Guests_PhoneNumber() {
          return {
            fontSize: {
              base: 10,
              lg: 12
            },
            lineHeight: 4,
            letterSpacing: -0.3,
            color: "secondary.300",
            _web: {
              flexDirection: "row",
              whiteSpace: "nowrap"
            }
          };
        },
        joinWaitlist_CTA_Cancel_Button_Text: function joinWaitlist_CTA_Cancel_Button_Text() {
          return {
            fontSize: {
              base: "16",
              lg: "20"
            },
            color: "amenitiesActionButtonsColor",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_CTA_JW_Button_Text: function joinWaitlist_CTA_JW_Button_Text() {
          return {
            fontSize: {
              base: "16px",
              lg: "20px"
            },
            color: "white",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_EstTime_Title: function joinWaitlist_EstTime_Title() {
          return {
            color: "#332C28",
            fontSize: 14,
            letterSpacing: -0.3,
            textAlign: "center"
          };
        },
        joinWaitlist_EstTime_Unvailable_Text: function joinWaitlist_EstTime_Unvailable_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_NoWait_Text: function joinWaitlist_EstTime_NoWait_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Text: function joinWaitlist_EstTime_Available_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            _ios: {
              fontSize: {
                base: "14"
              }
            },
            _android: {
              fontSize: {
                base: "14"
              }
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Time: function joinWaitlist_EstTime_Available_Time() {
          return {
            color: "#54301A",
            fontSize: 32,
            letterSpacing: -0.3,
            textAlign: "center",
            mb: 2
          };
        },
        joinWaitlist_WaitTimeInfo_Text: function joinWaitlist_WaitTimeInfo_Text() {
          return {
            color: "themeGrey",
            fontWeight: 300,
            fontSize: {
              base: "12",
              lg: "13"
            },
            lineHeight: 5,
            letterSpacing: -0.3
          };
        },
        joinWaitlist_Form_Error: function joinWaitlist_Form_Error() {
          return {
            color: "red.400",
            fontWeight: 400,
            fontSize: ["xs"],
            mt: 2
          };
        },
        joinWaitlist_Form_Mobile_Number_Info_Text: function joinWaitlist_Form_Mobile_Number_Info_Text() {
          return {
            color: "#7E7E7E",
            fontWeight: "400",
            fontSize: {
              base: 11,
              lg: 12
            },
            mt: {
              base: "6px",
              lg: 2
            }
          };
        },
        joinWaitlist_Form_Title: function joinWaitlist_Form_Title() {
          return {
            color: {
              base: "#303030",
              lg: "#2C2521"
            },
            fontWeight: 500,
            fontSize: {
              base: 16,
              lg: 22
            }
          };
        },
        joinWaitlist_Form_Checkbox: function joinWaitlist_Form_Checkbox() {
          return {
            color: "#606060",
            fontSize: 14,
            lineHeight: 4,
            fontWeight: 300,
            ml: 2,
            mr: 2.5,
            _web: {
              userSelect: "none"
            },
            flexShrink: 1
          };
        },
        joinWaitlist_Form_Filled_Status: function joinWaitlist_Form_Filled_Status() {
          return {
            fontSize: 12,
            color: "#993324"
          };
        },
        joinWaitlist_Form_Filled_PhoneNumber: function joinWaitlist_Form_Filled_PhoneNumber() {
          return {
            fontSize: 14,
            fontWeight: 300
          };
        },
        joinWaitlist_Form_Filled_Email: function joinWaitlist_Form_Filled_Email() {
          return {
            fontSize: 14,
            fontWeight: 300,
            mb: 2
          };
        },
        joinWaitlist_Form_Filled_Name: function joinWaitlist_Form_Filled_Name() {
          return {
            fontSize: 14,
            mb: 2
          };
        },
        joinWaitlist_WineWhileYouWait_Msg: function joinWaitlist_WineWhileYouWait_Msg() {
          return {
            fontWeight: "300",
            fontSize: {
              base: "sm",
              lg: "lg"
            },
            lineHeight: 5,
            maxWidth: "65%",
            flexWrap: "wrap",
            letterSpacing: -0.4,
            flex: 1,
            ml: {
              lg: 8
            },
            color: "#54301A"
          };
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#A2402A"
          };
        },
        joinWaitlist_Header_Title: function joinWaitlist_Header_Title() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "#303030",
            letterSpacing: -0.3
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 500,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor",
            textTransform: "uppercase"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#C16436"
          };
        },
        // JOIN WAITLIST END
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 5
          };
        },
        locationSearch_search_current_location_text: function locationSearch_search_current_location_text() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            color: "searchCurrentLocation"
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        nutritinalInfo: function nutritinalInfo() {
          return {
            fontSize: ["md", "md", "lg"],
            fontWeight: 500
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 600
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {// lineHeight not required for CS
        },
        legalDisclaimerText: {
          lineHeight: 3
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref37) {
          var isActive = _ref37.isActive;
          return {
            fontWeight: isActive ? 400 : 300
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: {
              base: "Roboto-Light",
              md: "Roboto-Regular"
            },
            color: "#020001",
            fontSize: 14
          };
        },
        increaseTextSize: function increaseTextSize(_ref38) {
          var styleSize = _ref38.styleSize;
          return {
            fontSize: styleSize
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#4E311D",
          fontSize: 24,
          width: "70%",
          lineHeight: 8
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#4E311D",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 200,
          color: "#4E311D",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          fontWeight: 200,
          color: "secondary.300",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4
        },
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {};
        },
        quantityText: function quantityText() {
          return {
            fontSize: {
              base: "xs",
              md: "lg"
            },
            fontWeight: 300,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200,
          color: "#C16436"
        },
        myAccountChangeLocationChangeText: {
          color: "#C16436",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          },
          textTransform: "uppercase"
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref39) {
          var prevMonthButtonDisabled = _ref39.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref40) {
          var nextMonthButtonDisabled = _ref40.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#4E311D"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          color: "myAccountSubTextColor",
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "#808080"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          my: 4,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "#808080"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "#C16436"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 10,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "#C16436"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#C16436"
          },
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "secondary200Mobile",
          _web: {
            color: "#C16436"
          }
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            color: "#303030"
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#737373",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          color: "#303030",
          fontWeight: 300
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#8E8E8E",
          mt: 3,
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mb: 2
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#8E8E8E",
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mt: 3,
          mb: 2
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontSize: 16,
          fontWeight: 300,
          color: "#303030",
          lineHeight: 5,
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "profileAddCardButtonText",
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#C16436",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3.5
            }
          },
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 300,
          color: "themeGrey",
          py: 2,
          textAlign: "center",
          mt: 5
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          mb: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4,
          mt: 1
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "saveCardAddButtonTextColor",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3.5
            }
          },
          fontWeight: 300
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          }
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 22,
          color: "#C16436"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "primary.100",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 16,
          fontWeight: 300,
          color: "orderHistoryDetailsText",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_mobileHeader_text: {
          color: "#2A2C25",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "secondary200Mobile",
          _web: {
            color: "#C16436"
          }
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 400
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 500,
          textAlign: "center",
          color: "white",
          fontSize: {
            base: 24,
            md: 32
          },
          width: "60%",
          lineHeight: 8
        },
        joinEClubHeadingSecondary: {
          fontWeight: 500,
          textAlign: "center",
          color: "white",
          fontSize: {
            base: 16,
            md: 18
          },
          width: "60%",
          lineHeight: 8
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "white",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3,
          color: "#606060"
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1",
          fontFamily: "body"
        },
        myAccountConfirmationHeadSubText: {
          color: "#808080",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        editProfileFullBottomButtonText: {
          fontSize: {
            base: 18,
            md: 16
          }
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 8
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref41) {
          var isSelected = _ref41.isSelected;
          return {
            bg: "#E5E5E5",
            borderWidth: isSelected ? 0 : 1,
            borderColor: "themeSectionSeparator",
            borderRadius: isSelected ? 0 : 13,
            shadow: 5,
            overflow: "hidden"
          };
        },
        listItemBox: {
          borderRadius: 10
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center",
          px: {
            base: 5,
            lg: 0
          }
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Outer_HStack: function joinWaitlist_StaticMap_Outer_HStack() {
          return {
            alignItems: "center",
            backgroundColor: "white",
            width: {
              md: "100%"
            }
          };
        },
        joinWaitlist_StaticMap_Inner_HStack: function joinWaitlist_StaticMap_Inner_HStack() {
          return {
            py: 4,
            pr: 4,
            flex: {
              md: 1
            },
            alignItems: "top",
            w: "100%",
            _ios: {
              alignItems: "flex-start"
            },
            _android: {
              alignItems: "flex-start"
            }
          };
        },
        joinWaitlist_StickyCTAButtons_Container: function joinWaitlist_StickyCTAButtons_Container() {
          return {
            bg: "white",
            py: 3,
            px: 4,
            space: 4,
            justifyContent: {
              lg: "flex-end"
            },
            _ios: {
              shadow: 15
            },
            _web: {
              shadow: 15
            }
          };
        },
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#D6D6D6"
          };
        },
        // JOIN WAITLIST END
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        //Location Search
        locationSearchSearchThisArea: {
          position: "absolute",
          top: {
            base: 4,
            md: 8
          },
          left: 0,
          alignItems: "center",
          width: "100%"
        },
        borderRadiusValue: function borderRadiusValue(_ref42) {
          var radiusValue = _ref42.radiusValue,
              topRadiusValue = _ref42.topRadiusValue,
              bottomRadiusValue = _ref42.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          _web: {
            mt: {
              base: 1.5,
              md: 1
            }
          }
        },
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "#FAF2EE",
          zIndex: 1
        },
        // My Account
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 8,
          borderColor: "#DCDCDC",
          borderWidth: 1
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 5
          },
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 8,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        // My Account
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "background.100",
          alignItems: "center",
          mb: 2
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          }
        }
      }
    },
    Image: {
      variants: {
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        breadSticksBannerImage: {
          w: "56px",
          h: "56px"
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref43) {
          var radiusValue = _ref43.radiusValue,
              topRadiusValue = _ref43.topRadiusValue,
              bottomRadiusValue = _ref43.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref44) {
          var active = _ref44.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        // JOIN WAITLIST START
        joinWaitlist_Guests_Container: function joinWaitlist_Guests_Container() {
          return {
            py: {
              lg: 2,
              base: 4
            },
            mb: 5,
            mx: 5,
            borderRadius: 16,
            shadow: 10,
            bg: "white",
            space: 3
          };
        },
        joinWaitlist_EstTime_Container: function joinWaitlist_EstTime_Container() {
          return {
            px: {
              base: 3,
              lg: 5
            },
            pt: {
              base: 3,
              lg: 5
            },
            mb: {
              base: 0,
              lg: 5
            },
            _ios: {
              pt: 2,
              mb: 0
            },
            _android: {
              pt: 2,
              mb: 0
            }
          };
        },
        joinWaitlist_EstTime_Unvailable_Text_Container: function joinWaitlist_EstTime_Unvailable_Text_Container() {
          return {
            alignItems: "center",
            mt: 0,
            mb: 0,
            _ios: {
              mt: 0.5,
              mb: 2
            },
            _android: {
              mt: 0.5,
              mb: 2
            }
          };
        },
        joinWaitlist_WaitTimeInfo_Container: function joinWaitlist_WaitTimeInfo_Container() {
          return {
            bg: "white",
            px: 5,
            py: 5,
            mb: 5,
            borderBottomWidth: 1,
            borderColor: "themeSectionSeparator",
            _ios: {
              py: 3
            },
            _android: {
              py: 3
            }
          };
        },
        joinWaitlist_EstimatedWaitTime_AvailableStatus_VStack: {
          p: 5,
          mb: {
            lg: 5
          },
          _ios: {
            mb: 2
          },
          _android: {
            mb: 2
          }
        },
        // JOIN WAITLIST END
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        }
      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },
        breadSticksBannerImageBox: {
          position: "absolute",
          top: "2px",
          left: 2,
          zIndex: 1
        },
        remoteCheckinContainer: {
          px: 6,
          py: 4,
          _web: {
            borderRadius: "12px"
          },
          borderWidth: 1,
          borderColor: "#F4F4F4",
          borderRadius: 3,
          width: {
            base: "100%",
            md: "335px"
          },
          shadow: 13,
          justifyContent: "space-around",
          alignItems: "center"
        },
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Roboto-Medium"
        },
        remoteCheckinWaitTimeParentBox: {
          bg: "#FAF2EE"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        OrderInfoBannerCartIconBox: {
          pb: 1
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#C16436",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#C16436",
          px: {
            base: 5,
            md: 9
          },
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 6,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref45) {
          var hasSub = _ref45.hasSub;
          return {
            mb: {
              base: hasSub && -1,
              md: hasSub && -4
            }
          };
        },
        configOptionBox: {
          borderRadius: 12
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 12,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: {
              base: "Roboto-Light",
              md: "Roboto-Regular"
            },
            color: "#020001",
            _web: {
              fontSize: {
                base: "13px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "393px",
                md: "413px"
              },
              pb: 10
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref46) {
          var isChild = _ref46.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 10,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 10
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 8,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref47) {
          var isMobile = _ref47.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        locationCard: {
          borderBottomWidth: 1,
          borderWidth: {
            base: 0,
            md: 1
          },
          borderColor: "allLocationsItemBoxBorderColor",
          borderRadius: {
            base: 0,
            md: 8
          },
          p: {
            base: 0,
            md: 1
          },
          mt: {
            base: 0,
            md: 4
          },
          mr: {
            base: 0,
            md: 8
          },
          _web: {
            minWidth: {
              base: "100%",
              md: "300px"
            }
          },
          width: "40%",
          bg: "#ffffff"
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref48) {
          var hideWaitlistSection = _ref48.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref49) {
          var isSticky = _ref49.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref50) {
          var isMobile = _ref50.isMobile,
              singleActionButton = _ref50.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#7C3932"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref51) {
          var isInStack = _ref51.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          borderRadius: 15,
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          borderRadius: 15,
          shadow: 11,
          mr: "8"
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Box: function joinWaitlist_StaticMap_Box() {
          return {
            position: "relative",
            overflow: "hidden",
            height: {
              base: 101,
              md: "100%"
            },
            w: {
              md: 230,
              lg: 170,
              xl: 230
            }
          };
        },
        joinWaitlist_StaticMap_Icon_Container: function joinWaitlist_StaticMap_Icon_Container() {
          return {
            pl: {
              lg: 5,
              base: 3
            },
            pr: {
              lg: 3,
              base: 2
            },
            mt: {
              lg: -1,
              base: -0.5
            }
          };
        },
        joinWaitlist_Form_Container: function joinWaitlist_Form_Container() {
          return {
            bg: "white",
            rounded: 12,
            p: 5,
            mx: 5,
            shadow: {
              base: 10,
              lg: "none"
            }
          };
        },
        joinWaitlist_Form_Filled_Container: function joinWaitlist_Form_Filled_Container() {
          return {
            bg: "white",
            rounded: 12,
            py: 5,
            px: 4,
            mx: 5,
            shadow: 10
          };
        },
        // JOIN WAITLIST END
        //Location search
        tabLocationsTopWidth: 0,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref52) {
          var isActive = _ref52.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref53) {
          var isSmallScreen = _ref53.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref54) {
          var isIOS = _ref54.isIOS;
          return {
            _text: {
              color: "white",
              pt: isIOS ? 1 : 0,
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 35,
          width: 28
        },
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "background.100"
        },
        eClubSignUpBox: {
          borderRadius: 20,
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          borderRadius: 20,
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        smartRecommendationModalHeadingContainer: {
          flex: 1
        },
        // My Account
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 12,
          bg: "white",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#EDEDED"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#EDEDED",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: "white",
          mt: 1
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 16,
          overflow: "hidden"
        },
        myAccount_paymentOptions_container: {
          paddingBottom: 5,
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "myAccountScreenBackroundColor",
            md: "white"
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#C16436",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 12,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "paymentOptionsHeaderColor",
          borderBottomWidth: 1,
          borderColor: "paymentOptionsBorderColor",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          py: 0.5,
          px: 3,
          _web: {
            py: 1
          }
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "60%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          w: "100%"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between"
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#F6F6F6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "white",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            pb: 4,
            pt: 2
          },
          _ios: {
            pb: 4,
            pt: 2
          },
          paddingX: 5,
          alignItems: "center",
          bg: {
            base: "#F6F6F6",
            md: "white"
          },
          _web: {
            py: {
              base: 5,
              md: 3.5
            },
            paddingX: {
              base: 5,
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          bg: "#FFFFFF"
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 4,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        // My Account ends
        myAccount_editFields_actionSheet_webBox: {
          pb: 7
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#EAEAEA",
          accessible: false,
          backgroundColor: "#FAF2EE",
          _web: {
            marginBottom: {
              base: 3,
              md: 6
            },
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref55) {
          var radiusValue = _ref55.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(91.85deg, #4B312A 0%, #C16436 100%)"
              }
            },
            borderRadius: radiusValue,
            borderTopRadius: radiusValue,
            borderBottomRadius: radiusValue,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: {
            base: "editProfileScreensBackgroundColor",
            md: "transparent"
          },
          _web: {
            height: "100%",
            overflowY: "auto",
            pt: 2
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 3,
          paddingBottom: 4,
          justifyContent: "center"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: "#FFFFFF"
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 59,
          width: 129,
          _web: {
            height: "60px",
            width: "82px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        borderRadiusValue: function borderRadiusValue(_ref56) {
          var radiusValue = _ref56.radiusValue,
              topRadiusValue = _ref56.topRadiusValue,
              bottomRadiusValue = _ref56.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4
        },
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: {
            base: "editProfileScreensBackgroundColor",
            md: "transparent"
          },
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            height: "100%"
          }
        },
        eClubBGGradient_box: {// empty
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 12
          };
        },
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 16,
          backgroundColor: "white",
          shadow: 4
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          marginRight: 5
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref57) {
          var isMobile = _ref57.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: {
              base: 0,
              md: 12
            },
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#F8F7F6",
          rounded: 12,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        },
        borderRadiusValue: function borderRadiusValue(_ref58) {
          var radiusValue = _ref58.radiusValue,
              topRadiusValue = _ref58.topRadiusValue,
              bottomRadiusValue = _ref58.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref59) {
          var radiusValue = _ref59.radiusValue;
          return {
            borderRadius: radiusValue
          };
        }
      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref60) {
          var radiusValue = _ref60.radiusValue,
              topRadiusValue = _ref60.topRadiusValue,
              bottomRadiusValue = _ref60.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref61) {
          var radiusValue = _ref61.radiusValue,
              topRadiusValue = _ref61.topRadiusValue,
              bottomRadiusValue = _ref61.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref62) {
          var radiusValue = _ref62.radiusValue,
              topRadiusValue = _ref62.topRadiusValue,
              bottomRadiusValue = _ref62.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%"
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          mt: 4,
          mb: 4,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3.5
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          mt: 4,
          mb: 4,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3.5
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    }
  },
  fontConfig: {
    Roboto: {
      100: {
        normal: "Roboto-Light"
      },
      200: {
        normal: "Roboto-Light"
      },
      300: {
        normal: "Roboto-Regular"
      },
      400: {
        normal: "Roboto-Medium"
      },
      500: {
        normal: "Roboto-Bold"
      },
      600: {
        normal: "Roboto-Bold"
      },
      700: {
        normal: "Roboto-Bold"
      }
    },
    Oswald: {
      100: {
        normal: "Oswald"
      },
      200: {
        normal: "Oswald"
      },
      300: {
        normal: "Oswald"
      },
      400: {
        normal: "Oswald"
      },
      500: {
        normal: "Oswald-Medium"
      },
      600: {
        normal: "Oswald-SemiBold"
      },
      700: {
        normal: "Oswald-Bold"
      }
    }
  },
  fonts: {
    heading: "Roboto",
    body: "Roboto",
    headingSecondary: "Oswald",
    youMightLikeText: "Roboto-Bold"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));